import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { NavLink, useLocation, useNavigate, Outlet } from 'react-router-dom';
import LogoutButton from '../../Components/LogoutButton';
import Spinner from '../../Components/Spinner';

const linksTo = [
  { link: '/dashboardAdx/stats', title: 'Главная' },
  { link: '/dashboardAdx/utm', title: 'UTM' },
  { link: '/dashboardAdx/promo', title: 'Уроки' },
  { link: '/dashboardAdx/Mini', title: 'Мини' },
  { link: '/dashboardAdx/courses', title: 'Курсы' },
  { link: '/dashboardAdx/training-access', title: 'Доступы' },
  { link: '/dashboardAdx/search', title: 'Пользователи' },
  { link: '/dashboardAdx/settings', title: 'Рассылка' },
];

const Dashboard = () => {
  const { user, loading } = useAuthContext();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();
  
  useEffect(() => {
    if (!loading && !user) navigate('/dashboardlogin');
  }, [user, loading, navigate]);

  // Закрываем меню при смене маршрута
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  if (loading) return <Spinner />;
  if (!user) return null;

  return (
    <div className="min-h-screen text-base text-gray-100">
      {/* Темный header */}
      <nav className="fixed top-0 left-0 right-0 shadow-lg z-50 px-6 py-3 bg-gray-900 flex items-center justify-between">
        {/* Левая часть: логотип и email */}
        <div className="flex items-center gap-4">
          <img src="/loader.svg" alt="logo" className="w-6 h-6 filter brightness-0 invert" />
          <span className="font-semibold text-gray-200">
            {user.email}
          </span>
        </div>

        {/* Кнопка бургер */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden focus:outline-none text-gray-300 hover:text-white transition-colors"
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>

        {/* Меню десктоп */}
        <div className="hidden md:flex items-center gap-3">
          {linksTo.map((item) => (
            <NavLink
              key={item.link}
              to={item.link}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md font-medium transition-colors ${
                  isActive 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`
              }
            >
              {item.title}
            </NavLink>
          ))}
          <LogoutButton />
        </div>
      </nav>

      {/* Мобильное меню - добавляем условие с isOpen и классы для анимации */}
      <div 
        className={`
          fixed md:hidden bg-gray-900 w-full shadow-lg z-40 transition-all duration-300 ease-in-out
          ${isOpen ? 'top-[60px] opacity-100 visible' : '-top-96 opacity-0 invisible'}
        `}
      >
        <div className="px-6 py-4 flex flex-col gap-2">
          {linksTo.map((item) => (
            <NavLink
              key={item.link}
              to={item.link}
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-md font-medium transition-colors ${
                  isActive 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`
              }
            >
              {item.title}
            </NavLink>
          ))}
          <div className="pt-2 border-t border-gray-700">
            <LogoutButton />
          </div>
        </div>
      </div>

      {/* Затемнение фона при открытом меню (опционально) */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
      
      <main className="pt-[60px] px-6 bg-gray-50 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
};

export default Dashboard;